/**
 * Returns the dealer-photo base URL (scheme + host) that ws-locations-data
 * resolves from the `ddc-account-assets` <Foo>Keeper endpoint and exposes on the
 * shared window.DDC.LocationsData object.
 *
 * Returns '' when unavailable (data widget not ready or older version), so
 * callers fall back to no image. The `/dealerphoto/<id>.jpg` path is appended
 * by buildLocationTiles.
 *
 * @returns {string} the base URL, or '' when unavailable
 */
export const getDealerPhotoBaseUrl = () =>
	(typeof window !== 'undefined' &&
		window.DDC?.LocationsData?.getDealerPhotoBaseUrl?.()) ||
	'';
